import { render } from "./SellerVerificationPage.vue?vue&type=template&id=61c66efe&scoped=true"
import script from "./SellerVerificationPage.vue?vue&type=script&lang=js"
export * from "./SellerVerificationPage.vue?vue&type=script&lang=js"

import "./SellerVerificationPage.vue?vue&type=style&index=0&id=61c66efe&lang=css"
import "./SellerVerificationPage.vue?vue&type=style&index=1&id=61c66efe&lang=css"
import "./SellerVerificationPage.vue?vue&type=style&index=2&id=61c66efe&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c66efe"]])

export default __exports__